import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const LanguageContext = createContext({ lang: "de", setLang: () => {}, t: translations.de });

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("lotus_lang") || "de");

  useEffect(() => {
    localStorage.setItem("lotus_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const value = { lang, setLang, t: translations[lang] };
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export const useLang = () => useContext(LanguageContext);
